// Command palette style picker for crops
const CropPicker = ({
  crops = [],
  value,
  onChange,
  placeholder,
  allowEmptyLabel,
  inputClassName,
  title,
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [highlight, setHighlight] = useState(0);
  const ref = useRef(null);

  const options = useMemo(() => {
    if (!query) return crops || [];
    const q = query.toLowerCase();
    return (crops || []).filter((c) =>
      (c.name || "").toLowerCase().includes(q)
    );
  }, [crops, query]);

  const selected = useMemo(
    () => (crops || []).find((c) => String(c.id) === String(value)) || null,
    [crops, value]
  );

  useEffect(() => {
    if (!open) setQuery("");
  }, [open]);
  useEffect(() => {
    if (!open) return;
    function handleClickAway(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    }
    function handleGlobalKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", handleClickAway);
    window.addEventListener("keydown", handleGlobalKey);
    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      window.removeEventListener("keydown", handleGlobalKey);
    };
  }, [open]);
  useEffect(() => {
    setHighlight(0);
  }, [options, allowEmptyLabel]);
  const handleKey = (e) => {
    if (!open) return;
    const renderedLen = (allowEmptyLabel ? 1 : 0) + options.length;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlight((h) => Math.min(h + 1, renderedLen - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlight((h) => Math.max(h - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (allowEmptyLabel && highlight === 0) {
        onChange("");
        setOpen(false);
      } else {
        const idx = highlight - (allowEmptyLabel ? 1 : 0);
        if (options[idx]) {
          onChange(options[idx].id);
          setOpen(false);
        }
      }
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };
  return (
    <div className="relative" style={{ minWidth: 180 }} ref={ref}>
      <input
        type="text"
        placeholder={placeholder}
        title={title}
        value={open ? query : selected ? selected.name : ""}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onKeyDown={handleKey}
        className={
          inputClassName ||
          "w-44 px-3 py-2 text-sm rounded-md border border-gray-200 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-500"
        }
      />
      {open && (
        <ul className="absolute z-30 left-0 right-0 max-h-60 overflow-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-600 mt-1 list-none p-0 shadow-sm rounded-md">
          {options.length === 0 && (
            <li className="p-2 text-gray-500 dark:text-gray-400">No results</li>
          )}
          {allowEmptyLabel && (
            <li
              key="__empty"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange("");
                setOpen(false);
              }}
              onMouseEnter={() => setHighlight(0)}
              className={`flex items-center gap-2 px-3 py-1.5 cursor-pointer rounded-md ${
                highlight === 0
                  ? "text-gray-950 bg-emerald-50 dark:text-white dark:bg-gray-800"
                  : "text-gray-600 dark:text-gray-300"
              } hover:bg-emerald-50 dark:hover:bg-gray-800`}
            >
              <span className="text-sm italic">{allowEmptyLabel}</span>
            </li>
          )}
          {options.map((c, i) => {
            const renderedIndex = i + (allowEmptyLabel ? 1 : 0);
            const isSelected = renderedIndex === highlight;
            return (
              <li
                key={c.id}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(c.id);
                  setOpen(false);
                }}
                onMouseEnter={() => setHighlight(renderedIndex)}
                className={`flex items-center gap-2 px-3 py-1.5 cursor-pointer rounded-md ${
                  isSelected
                    ? "text-gray-950 bg-emerald-50 dark:text-white dark:bg-gray-800"
                    : "text-gray-600 dark:text-gray-300"
                } hover:bg-emerald-50 dark:hover:bg-gray-800`}
              >
                <span className="text-sm truncate">{c.name}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
import api from "../api";
// Command palette style picker for countries
const CountryPicker = ({
  countries = [],
  value,
  onChange,
  placeholder,
  allowEmptyLabel,
  inputClassName,
  title,
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [highlight, setHighlight] = useState(0);
  const ref = useRef(null);

  const options = useMemo(() => {
    if (!query) return countries || [];
    const q = query.toLowerCase();
    return (countries || []).filter((c) =>
      (c.name || "").toLowerCase().includes(q)
    );
  }, [countries, query]);

  const selected = useMemo(
    () => (countries || []).find((c) => String(c.id) === String(value)) || null,
    [countries, value]
  );

  useEffect(() => {
    if (!open) setQuery("");
  }, [open]);
  useEffect(() => {
    if (!open) return;
    function handleClickAway(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    }
    function handleGlobalKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", handleClickAway);
    window.addEventListener("keydown", handleGlobalKey);
    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      window.removeEventListener("keydown", handleGlobalKey);
    };
  }, [open]);
  useEffect(() => {
    setHighlight(0);
  }, [options, allowEmptyLabel]);
  const handleKey = (e) => {
    if (!open) return;
    const renderedLen = (allowEmptyLabel ? 1 : 0) + options.length;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlight((h) => Math.min(h + 1, renderedLen - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlight((h) => Math.max(h - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (allowEmptyLabel && highlight === 0) {
        onChange("");
        setOpen(false);
      } else {
        const idx = highlight - (allowEmptyLabel ? 1 : 0);
        if (options[idx]) {
          onChange(options[idx].id);
          setOpen(false);
        }
      }
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };
  return (
    <div className="relative" style={{ minWidth: 180 }} ref={ref}>
      <input
        type="text"
        placeholder={placeholder}
        title={title}
        value={open ? query : selected ? selected.name : ""}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onKeyDown={handleKey}
        className={
          inputClassName ||
          "w-44 px-3 py-2 text-sm rounded-md border border-gray-200 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-500"
        }
      />
      {open && (
        <ul className="absolute z-30 left-0 right-0 max-h-60 overflow-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-600 mt-1 list-none p-0 shadow-sm rounded-md">
          {options.length === 0 && (
            <li className="p-2 text-gray-500 dark:text-gray-400">No results</li>
          )}
          {allowEmptyLabel && (
            <li
              key="__empty"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange("");
                setOpen(false);
              }}
              onMouseEnter={() => setHighlight(0)}
              className={`flex items-center gap-2 px-3 py-1.5 cursor-pointer rounded-md ${
                highlight === 0
                  ? "text-gray-950 bg-emerald-50 dark:text-white dark:bg-gray-800"
                  : "text-gray-600 dark:text-gray-300"
              } hover:bg-emerald-50 dark:hover:bg-gray-800`}
            >
              <span className="text-sm italic">{allowEmptyLabel}</span>
            </li>
          )}
          {options.map((c, i) => {
            const renderedIndex = i + (allowEmptyLabel ? 1 : 0);
            const isSelected = renderedIndex === highlight;
            return (
              <li
                key={c.id}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(c.id);
                  setOpen(false);
                }}
                onMouseEnter={() => setHighlight(renderedIndex)}
                className={`flex items-center gap-2 px-3 py-1.5 cursor-pointer rounded-md ${
                  isSelected
                    ? "text-gray-950 bg-emerald-50 dark:text-white dark:bg-gray-800"
                    : "text-gray-600 dark:text-gray-300"
                } hover:bg-emerald-50 dark:hover:bg-gray-800`}
              >
                <span className="text-sm truncate">{c.name}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
import React, { useState, useMemo, useRef, useEffect } from "react";
import axios from "@/api";
import TriStateSelect from "./TriStateSelect";
import { MassPreviewDialog, MassResult, MassError } from "./MassUpdateReview";
import SearchSelect from "@/pages/SearchSelect";
import { NON_NEGATIVE_NUMBER } from "@/utils/trialFieldLimits";
import { apiErrorMessage, displayValue, MASS_FIELD_LABELS, trialCount } from "@/utils/massUpdate";

const SAMPLES_INPUT =
  "w-24 rounded-lg border border-gray-200 px-3 py-2 text-sm leading-6 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100";

const UserPicker = ({
  users = [],
  value,
  onChange,
  placeholder,
  allowEmptyLabel,
  inputClassName,
  title,
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [highlight, setHighlight] = useState(0);
  const ref = useRef(null);

  const options = useMemo(() => {
    if (!query) return users || [];
    const q = query.toLowerCase();
    return (users || []).filter((u) => {
      const name = (
        u.Name ||
        u.name ||
        u.displayName ||
        u.display_name ||
        u.fullname ||
        u.full_name ||
        `${u.first_name || ""} ${u.last_name || ""}` ||
        u.username ||
        ""
      ).toLowerCase();
      const initials = (u.Initials || u.initials || "").toLowerCase();
      const email = (u.email || "").toLowerCase();
      return name.includes(q) || initials.includes(q) || email.includes(q);
    });
  }, [users, query]);

  const getDisplayName = (u) => {
    if (!u) return "";
    if (u.Name) return u.Name;
    if (u.name) return u.name;
    if (u.displayName) return u.displayName;
    if (u.display_name) return u.display_name;
    if (u.fullname) return u.fullname;
    if (u.full_name) return u.full_name;
    if (u.first_name || u.last_name)
      return `${u.first_name || ""}${u.first_name && u.last_name ? " " : ""}${
        u.last_name || ""
      }`.trim();
    if (u.username) return u.username;
    return u.email || "";
  };

  const selected = useMemo(
    () => (users || []).find((u) => String(u.id) === String(value)) || null,
    [users, value]
  );

  useEffect(() => {
    if (!open) setQuery("");
  }, [open]);

  // Close on outside click or Escape key
  useEffect(() => {
    if (!open) return;
    function handleClickAway(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    }
    function handleGlobalKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", handleClickAway);
    window.addEventListener("keydown", handleGlobalKey);
    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      window.removeEventListener("keydown", handleGlobalKey);
    };
  }, [open]);

  // reset highlight whenever options or allowEmptyLabel change
  useEffect(() => {
    setHighlight(0);
  }, [options, allowEmptyLabel]);

  const handleKey = (e) => {
    if (!open) return;
    const renderedLen = (allowEmptyLabel ? 1 : 0) + options.length;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlight((h) => Math.min(h + 1, renderedLen - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlight((h) => Math.max(h - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (allowEmptyLabel && highlight === 0) {
        onChange("");
        setOpen(false);
      } else {
        const idx = highlight - (allowEmptyLabel ? 1 : 0);
        if (options[idx]) {
          onChange(options[idx].id);
          setOpen(false);
        }
      }
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  return (
    <div className="relative" style={{ minWidth: 180 }} ref={ref}>
      <input
        type="text"
        placeholder={placeholder}
        title={title}
        value={
          open
            ? query
            : selected
            ? `${getDisplayName(selected)}${
                selected.Initials || selected.initials
                  ? ` (${selected.Initials || selected.initials})`
                  : ""
              }`
            : ""
        }
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onKeyDown={handleKey}
        className={
          inputClassName ||
          "w-44 px-3 py-2 text-sm rounded-md border border-gray-200 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-emerald-500"
        }
      />
      {open && (
        <ul className="absolute z-30 left-0 right-0 max-h-60 overflow-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-600 mt-1 list-none p-0 shadow-sm rounded-md">
          {options.length === 0 && (
            <li className="p-2 text-gray-500 dark:text-gray-400">No results</li>
          )}
          {allowEmptyLabel && (
            <li
              key="__empty"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange("");
                setOpen(false);
              }}
              onMouseEnter={() => setHighlight(0)}
              className={`flex items-center gap-2 px-3 py-1.5 cursor-pointer rounded-md ${
                highlight === 0
                  ? "text-gray-950 bg-emerald-50 dark:text-white dark:bg-gray-800"
                  : "text-gray-600 dark:text-gray-300"
              } hover:bg-emerald-50 dark:hover:bg-gray-800`}
            >
              <span className="text-sm italic">{allowEmptyLabel}</span>
            </li>
          )}
          {options.map((u, i) => {
            const renderedIndex = i + (allowEmptyLabel ? 1 : 0);
            const isSelected = renderedIndex === highlight;
            return (
              <li
                key={u.id}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(u.id);
                  setOpen(false);
                }}
                onMouseEnter={() => setHighlight(renderedIndex)}
                className={`flex items-center gap-2 px-3 py-1.5 cursor-pointer rounded-md ${
                  isSelected
                    ? "text-gray-950 bg-emerald-50 dark:text-white dark:bg-gray-800"
                    : "text-gray-600 dark:text-gray-300"
                } hover:bg-emerald-50 dark:hover:bg-gray-800`}
              >
                {u.Initials || u.initials ? (
                  <span className="inline-flex items-center justify-center w-7 h-6 rounded-md bg-emerald-50 text-emerald-700 text-xs font-semibold">
                    {u.Initials || u.initials}
                  </span>
                ) : null}
                <span className="text-sm truncate">{getDisplayName(u)}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

// UI keys whose API field has another name (FT, PI, NIT, TreatmentCount, ... are sent as-is)
const API_FIELDS = {
  SD: "studydirector",
  crop: "crop_id",
  country: "country_id",
};

function hasChanges(editValues) {
  return Object.entries(editValues || {}).some(
    ([k, v]) => v !== "" && v != null
  );
}

const UpdateMultipleTrialsComponent = ({
  searchQuery,
  setSearchQuery,
  editValues,
  setEditValues,
  showCopyToDialog,
  setShowCopyToDialog,
  newTrialNumber,
  setNewTrialNumber,
  confirmCopy,
  users = [],
  selectedTrialIds = [],
  setSelectedTrialIds,
  refreshTrials, // optional callback to refresh the table below
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // The API's plan for the selected trials ({ changes, rows }), shown before anything is saved
  const [preview, setPreview] = useState(null);
  // The update's response, shown afterwards: how many were updated, which were skipped and why
  const [result, setResult] = useState(null);
  // What Retry runs again (the preview or the update). A ref: it never needs a re-render
  const retryRef = useRef(null);
  const [countries, setCountries] = useState([]);
  const [crops, setCrops] = useState([]);
  // Fetch countries and crops on mount
  useEffect(() => {
    (async () => {
      try {
        const res = await api.post("/masterdata/countries", {});
        let arr = Array.isArray(res.data) ? res.data : [];
        arr = arr.map((c) => ({
          id: c.id ?? c.ID ?? c.value ?? c.name,
          name: c.name ?? c.label ?? c.value ?? c.ID ?? c.id,
        }));
        setCountries(arr.filter((c) => c.name));
      } catch (e) {
        setCountries([]);
      }
      try {
        const res = await api.post("/masterdata/crops", {});
        let arr = Array.isArray(res.data) ? res.data : [];
        arr = arr.map((c) => ({
          id: c.id ?? c.ID ?? c.value ?? c.name,
          name: c.name ?? c.label ?? c.value ?? c.ID ?? c.id,
        }));
        setCrops(arr.filter((c) => c.name));
      } catch (e) {
        setCrops([]);
      }
    })();
  }, []);

  // The active study and trial types, as for a new trial (archived ones are not offered)
  const [studyTypes, setStudyTypes] = useState([]);
  const [trialTypes, setTrialTypes] = useState([]);
  useEffect(() => {
    let ignore = false;
    const load = (url, set) =>
      api.post(url, { active_only: true })
        .then((res) => { if (!ignore) set(Array.isArray(res.data) ? res.data : []); })
        .catch(() => { if (!ignore) set([]); });
    load("/masterdata/studytypes", setStudyTypes);
    load("/masterdata/trialtype", setTrialTypes);
    return () => {
      ignore = true;
    };
  }, []);

  const canUpdate =
    selectedTrialIds && selectedTrialIds.length > 0 && hasChanges(editValues);

  // Map UI change keys to backend API fields. The API drops keys it does not know, so every
  // key sent must match a field in TrialController::massUpdate (e.g. crop_id, not crop).
  function getApiChanges(editValues) {
    const changes = {};
    for (const [k, v] of Object.entries(editValues || {})) {
      if (v === "" || v == null) continue;
      changes[API_FIELDS[k] || k] = v;
    }
    return changes;
  }

  // Runs an API call, showing its error with Retry (which runs it again)
  async function run(action, fallback) {
    retryRef.current = () => run(action, fallback);
    setLoading(true);
    setError(null);
    try {
      await action();
    } catch (e) {
      setError(apiErrorMessage(e, fallback));
    } finally {
      setLoading(false);
    }
  }

  async function refreshTable() {
    if (typeof refreshTrials === "function") {
      try {
        await refreshTrials();
      } catch (refreshError) {
        console.error('Error refreshing trials table:', refreshError);
        // Don't throw here, the update was successful
      }
    } else if (typeof window !== "undefined") {
      // fallback: emit a custom event
      window.dispatchEvent(new Event("trialsMassUpdateSuccess"));
    }
  }

  // Step 1: ask the API what the change would do to each selected trial (nothing is saved)
  function handlePreview() {
    const changes = getApiChanges(editValues);
    run(async () => {
      setResult(null);
      const { data } = await axios.post("/trials/massupdate/preview", { ids: selectedTrialIds, changes });
      setPreview({ changes, rows: data.trials });
    }, "Failed to preview the update.");
  }

  // Step 2: update the trials the user kept in the preview
  function handleApply(ids) {
    const { changes } = preview;
    run(async () => {
      try {
        const { data } = await axios.post("/trials/massupdate", { ids, changes });
        setResult(data);
        setEditValues({});
        setSelectedTrialIds?.([]);
      } finally {
        // Closed either way, so the result or the error below is not hidden behind it
        setPreview(null);
      }
      await refreshTable();
    }, "Failed to update trials.");
  }

  const inputStyle = {
    width: "150px",
    padding: "6px",
    fontSize: "14px",
  };

  // Build human-friendly summary for confirmation
  const idToUser = useMemo(() => {
    const map = new Map();
    (users || []).forEach((u) => map.set(String(u.id), u));
    return map;
  }, [users]);

  const getUserLabel = (id) => {
    if (!id) return "";
    const u = idToUser.get(String(id));
    if (!u) return String(id);
    const name = (
      u.Name ||
      u.name ||
      u.displayName ||
      u.display_name ||
      u.fullname ||
      u.full_name ||
      `${u.first_name || ""} ${u.last_name || ""}` ||
      u.username ||
      u.email ||
      ""
    ).trim();
    const initials =
      u.Initials || u.initials ? ` (${u.Initials || u.initials})` : "";
    return `${name}${initials}`;
  };

  // Names for the ids in the preview (users, crops, countries)
  const nameOf = (list) => (id) => list.find((c) => String(c.id) === String(id))?.name;
  const valueNames = {
    studydirector: getUserLabel,
    FT: getUserLabel,
    PI: getUserLabel,
    crop_id: nameOf(crops),
    country_id: nameOf(countries),
    study_type_id: nameOf(studyTypes),
    trial_type_id: nameOf(trialTypes),
  };

  const describeRow = (row) => {
    if (row.reason) return row.reason;
    if (row.outcome === "unchanged") return "Already has these values";
    return (
      <ul className="space-y-0.5">
        {row.changes.map((c) => (
          <li key={c.field}>
            <span className="font-medium">{MASS_FIELD_LABELS[c.field] ?? c.field}:</span>{" "}
            {displayValue(c.field, c.old, valueNames)} → {displayValue(c.field, c.new, valueNames)}
          </li>
        ))}
        {row.effects.map((effect) => (
          <li key={effect} className="text-amber-700 dark:text-amber-300">{effect}</li>
        ))}
      </ul>
    );
  };

  const previewTitle = preview
    ? `You are changing ${Object.keys(preview.changes).map((f) => MASS_FIELD_LABELS[f] ?? f).join(", ")} on ${trialCount(preview.rows.length)}`
    : "";

  return (
    <form className="dark:text-gray-100" onSubmit={(e) => e.preventDefault()}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-4">
        {/* Crop as command palette. No Year or Local Reference: they are set per trial, not in bulk */}
        <div className="space-y-1">
          <label className="inline-block font-medium" htmlFor="crop">
            Crop
          </label>
          <CropPicker
            crops={crops}
            value={editValues.crop || ""}
            onChange={(id) => setEditValues((prev) => ({ ...prev, crop: id }))}
            placeholder="Keep current"
            title="Leave blank to keep each trial's Crop"
            allowEmptyLabel="Leave Crop unchanged"
            inputClassName="block w-full rounded-lg border border-gray-200 px-3 py-2 leading-6 bg-white text-gray-900 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-400 dark:focus:border-emerald-500"
          />
        </div>
        {/* Study Type and Trial Type: the active ones, as for a new trial */}
        {[
          ["study_type_id", "Study Type", studyTypes],
          ["trial_type_id", "Trial Type", trialTypes],
        ].map(([field, label, list]) => (
          <div key={field} className="space-y-1" data-testid={`mass-${field}`}>
            <span className="inline-block font-medium">{label}</span>
            <SearchSelect
              options={list.map((t) => ({ value: t.id, label: t.name }))}
              value={editValues[field] ?? null}
              onChange={(opt) => setEditValues((prev) => ({ ...prev, [field]: opt ? opt.value : "" }))}
              placeholder={`Leave ${label} unchanged`}
            />
          </div>
        ))}

        {/* Counts and plot size, with Edit Trial's limits (no negative numbers) */}
        {[
          ["TreatmentCount", "Treatment Count", "1"],
          ["ReplicationCount", "Replication Count", "1"],
          ["PlotSizeL", "Plot Size L", "any"],
          ["PlotSizeB", "Plot Size W", "any"],
        ].map(([field, label, step]) => (
          <div key={field} className="space-y-1">
            <label className="inline-block font-medium" htmlFor={field}>
              {label}
            </label>
            <input
              id={field}
              type="number"
              step={step}
              {...NON_NEGATIVE_NUMBER}
              placeholder={`Leave ${label} unchanged`}
              value={editValues[field] ?? ""}
              onChange={(e) => setEditValues((prev) => ({ ...prev, [field]: e.target.value }))}
              className="block w-full rounded-lg border border-gray-200 px-3 py-2 leading-6 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-emerald-500"
            />
          </div>
        ))}

        {/* NIT, TGW and Germination Test with their sample counts. The samples are not set on a
            trial where the test is No (the preview says so) */}
        <div className="space-y-1">
          <label className="inline-block font-medium" htmlFor="NIT">
            NIT
          </label>
          <div className="flex items-center gap-3">
            <TriStateSelect
              id="NIT"
              value={editValues.NIT}
              unchangedLabel="Leave NIT unchanged"
              onChange={(value) => setEditValues((prev) => ({ ...prev, NIT: value }))}
            />
            <label htmlFor="NIT_Samples">NIT Samples</label>
            <input
              id="NIT_Samples"
              type="number"
              {...NON_NEGATIVE_NUMBER}
              value={editValues.NIT_Samples || ""}
              onChange={(e) =>
                setEditValues((prev) => ({
                  ...prev,
                  NIT_Samples: e.target.value,
                }))
              }
              className={SAMPLES_INPUT}
              placeholder="Count"
            />
          </div>
        </div>
        <div className="space-y-1">
          <label className="inline-block font-medium" htmlFor="TGW">
            TGW
          </label>
          <div className="flex items-center gap-3">
            <TriStateSelect
              id="TGW"
              value={editValues.TGW}
              unchangedLabel="Leave TGW unchanged"
              onChange={(value) => setEditValues((prev) => ({ ...prev, TGW: value }))}
            />
            <label htmlFor="TGW_Samples">TGW Samples</label>
            <input
              id="TGW_Samples"
              type="number"
              {...NON_NEGATIVE_NUMBER}
              value={editValues.TGW_Samples || ""}
              onChange={(e) =>
                setEditValues((prev) => ({
                  ...prev,
                  TGW_Samples: e.target.value,
                }))
              }
              className={SAMPLES_INPUT}
              placeholder="Count"
            />
          </div>
        </div>
        <div className="space-y-1">
          <label className="inline-block font-medium" htmlFor="GerminationTest">
            Germination Test
          </label>
          <div className="flex items-center gap-3">
            <TriStateSelect
              id="GerminationTest"
              value={editValues.GerminationTest}
              unchangedLabel="Leave Germination Test unchanged"
              onChange={(value) => setEditValues((prev) => ({ ...prev, GerminationTest: value }))}
            />
            <label htmlFor="GT_Samples">Germination Test Samples</label>
            <input
              id="GT_Samples"
              type="number"
              {...NON_NEGATIVE_NUMBER}
              value={editValues.GT_Samples || ""}
              onChange={(e) =>
                setEditValues((prev) => ({
                  ...prev,
                  GT_Samples: e.target.value,
                }))
              }
              className={SAMPLES_INPUT}
              placeholder="Count"
            />
          </div>
        </div>
        {/* Country field as command palette */}
        <div className="space-y-1">
          <label className="inline-block font-medium" htmlFor="country">
            Country
          </label>
          <CountryPicker
            countries={countries}
            value={editValues.country || ""}
            onChange={(id) =>
              setEditValues((prev) => ({ ...prev, country: id }))
            }
            placeholder="Keep current"
            title="Leave blank to keep each trial's Country"
            allowEmptyLabel="Leave Country unchanged"
            inputClassName="block w-full rounded-lg border border-gray-200 px-3 py-2 leading-6 bg-white text-gray-900 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-400 dark:focus:border-emerald-500"
          />
        </div>

        <div className="space-y-1">
          <label className="inline-block font-medium">
            Principal Investigator (PI)
          </label>
          <UserPicker
            users={users}
            value={editValues.PI || ""}
            onChange={(id) => setEditValues((prev) => ({ ...prev, PI: id }))}
            placeholder="Keep current"
            title="Leave blank to keep each trial's PI"
            allowEmptyLabel="Leave PI unchanged"
            inputClassName="block w-full rounded-lg border border-gray-200 px-3 py-2 leading-6 bg-white text-gray-900 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-400 dark:focus:border-emerald-500"
          />
        </div>
        <div className="space-y-1">
          <label className="inline-block font-medium">
            Study Director (SD)
          </label>
          <UserPicker
            users={users}
            value={editValues.SD || ""}
            onChange={(id) => setEditValues((prev) => ({ ...prev, SD: id }))}
            placeholder="Keep current"
            title="Leave blank to keep each trial's Study Director"
            allowEmptyLabel="Leave SD unchanged"
            inputClassName="block w-full rounded-lg border border-gray-200 px-3 py-2 leading-6 bg-white text-gray-900 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-400 dark:focus:border-emerald-500"
          />
        </div>
        <div className="space-y-1">
          <label className="inline-block font-medium">
            Field Technician (FT)
          </label>
          <UserPicker
            users={users}
            value={editValues.FT || ""}
            onChange={(id) => setEditValues((prev) => ({ ...prev, FT: id }))}
            placeholder="Keep current"
            title="Leave blank to keep each trial's Field Technician"
            allowEmptyLabel="Leave FT unchanged"
            inputClassName="block w-full rounded-lg border border-gray-200 px-3 py-2 leading-6 bg-white text-gray-900 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-400 dark:focus:border-emerald-500"
          />
        </div>
      </div>

      {/* Buttons in lower right */}
      <div className="flex justify-end gap-2 pt-4">
        <button
          type="button"
          onClick={() => {
            try {
              setEditValues({});
            } catch (e) {}
            try {
              setSearchQuery("");
            } catch (e) {}
            try {
              setNewTrialNumber("");
            } catch (e) {}
            try {
              setShowCopyToDialog(false);
            } catch (e) {}
          }}
          className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm leading-5 font-semibold text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-xs focus:ring-3 focus:ring-gray-300/25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600/40 dark:active:border-gray-700"
        >
          Reset
        </button>
        <button
          type="button"
          onClick={handlePreview}
          className={`inline-flex items-center justify-center gap-2 rounded-lg border border-emerald-700 bg-emerald-700 px-3 py-2 text-sm leading-5 font-semibold text-white hover:border-emerald-600 hover:bg-emerald-600 hover:text-white focus:ring-3 focus:ring-emerald-400/50 active:border-emerald-700 active:bg-emerald-700 dark:focus:ring-emerald-400/90 ${
            !canUpdate ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={!canUpdate || loading}
        >
          Preview update
        </button>
      </div>

      {preview && (
        <MassPreviewDialog
          title={previewTitle}
          rows={preview.rows}
          outcomes={{
            change: { label: "Will change", tone: "green" },
            unchanged: { label: "No change", tone: "gray" },
            blocked: { label: "Skipped", tone: "amber" },
          }}
          applicable={["change"]}
          describe={describeRow}
          confirmText="Update"
          busy={loading}
          onConfirm={handleApply}
          onCancel={() => setPreview(null)}
        />
      )}
      {error && <MassError message={error} onRetry={() => retryRef.current?.()} disabled={loading} />}
      {result && (
        <MassResult
          summary={`Updated ${trialCount(result.updated)}.${result.unchanged ? ` ${trialCount(result.unchanged)} already had these values.` : ""}`}
          skipped={result.skipped}
          onClose={() => setResult(null)}
        />
      )}

      {showCopyToDialog && (
        <div
          style={{
            padding: 20,
            border: "1px solid gray",
            background: "#fff",
            position: "absolute",
            top: "30%",
            left: "40%",
            zIndex: 10,
          }}
        >
          <div style={{ marginBottom: "10px" }}>New Trial</div>
          <input
            value={newTrialNumber}
            onChange={(e) => setNewTrialNumber(e.target.value)}
            style={{ marginRight: "10px", padding: "6px", fontSize: "14px" }}
          />
          <button onClick={confirmCopy}>OK</button>
          <button onClick={() => setShowCopyToDialog(false)}>Cancel</button>
        </div>
      )}
    </form>
  );
};

export default UpdateMultipleTrialsComponent;
